import { useState, type ComponentType } from 'react';
import {
  AboutRamiPage,
  AdvancedPage,
  BackupsPage,
  ConversationsPage,
  DevicesPage,
  InitiativesPage,
  MemoryPage,
  OverviewPage,
  PersonaPage,
  PrivacyPage,
  ProvidersPage,
  TrashPage,
  UsagePage
} from './pages';
import { MediaLibraryPage } from './media-library';

const navigation = [
  ['overview', 'النظرة العامة'],
  ['persona', 'شخصية رامي'],
  ['memory', 'الذاكرة'],
  ['conversations', 'المحادثات والتسجيلات'],
  ['media', 'مكتبة الوسائط'],
  ['devices', 'الأجهزة والتواصل'],
  ['initiatives', 'المبادرات والإشعارات'],
  ['providers', 'الذكاء والمزودات'],
  ['usage', 'الاستخدام والموارد'],
  ['backups', 'النسخ والأمان'],
  ['advanced', 'السجل المتقدم']
  ,['about', 'عن رامي']
  ,['privacy', 'الخصوصية والحذف']
  ,['trash', 'سلة المحذوفات']
] as const;

const pages: Record<string, ComponentType> = {
  overview: OverviewPage,
  persona: PersonaPage,
  memory: MemoryPage,
  conversations: ConversationsPage,
  devices: DevicesPage,
  initiatives: InitiativesPage,
  providers: ProvidersPage,
  usage: UsagePage,
  backups: BackupsPage,
  advanced: AdvancedPage,
  about: AboutRamiPage,
  privacy: PrivacyPage
  ,media: MediaLibraryPage
  ,trash: TrashPage
};

export function AdminLayout({ activePage, navigate }: { activePage: string; navigate: (path: string) => void }) {
  const [open, setOpen] = useState(false);
  const Page = pages[activePage] ?? OverviewPage;
  return <main className="owner-layout">
    <aside className="owner-nav" aria-label="أقسام لوحة المالك">
      <div>
        <p className="eyebrow">إدارة خاصة</p>
        <h1>لوحة المالك</h1>
        <button
          type="button"
          className="owner-nav__toggle"
          aria-expanded={open}
          aria-controls="owner-nav-list"
          onClick={() => setOpen((value) => !value)}
        >
          {open ? 'إخفاء الأقسام' : 'عرض الأقسام'}
        </button>
      </div>
      <nav id="owner-nav-list" className={open ? 'owner-nav__list is-open' : 'owner-nav__list'}>
        {navigation.map(([path, label]) => <button
          key={path}
          className={activePage === path ? 'active' : ''}
          aria-current={activePage === path ? 'page' : undefined}
          onClick={() => { navigate(`/owner/${path}`); setOpen(false); }}
        >{label}</button>)}
      </nav>
    </aside>
    <div className="owner-content"><Page /></div>
  </main>;
}
